// OrderScoreBadge — nhãn xanh/vàng/đỏ của MỘT đơn.
//
// Dùng chung cho danh sách đơn, lịch, hậu kỳ và CSKH: bốn nơi cùng nhìn một
// đơn thì phải thấy cùng một màu, và cách chắc nhất là chỉ có một chỗ quyết
// định màu đó trông thế nào.
//
// ⚠️ Nhãn chỉ hiện khi CÓ điểm. Đơn chưa chấm không hiện gì — một nhãn xám
// "chưa có" nằm trên mọi dòng chỉ làm bảng ồn hơn mà không nói thêm điều gì.
import type { OrderScore } from "../api";
import { blockMeasured } from "@/features/quality/framework";

const STYLE: Record<string, { cls: string; label: string }> = {
  green: { cls: "bg-success/15 text-success-text", label: "Đơn tốt" },
  yellow: { cls: "bg-warning/15 text-warning-text", label: "Đơn có vấn đề" },
  red: { cls: "bg-destructive/15 text-destructive", label: "Đơn kém" },
};

export function OrderScoreBadge({ score }: { score: OrderScore | undefined }) {
  if (!score) return null;
  const s = STYLE[score.color];
  if (!s) return null;
  return (
    <span
      className={`ml-1 inline-block rounded px-1.5 py-0.5 text-[11px] font-medium ${s.cls}`}
      title={`${s.label} — ${score.totalPts}/100 (chất lượng ${score.qualityPts ?? 0}/40 · tiến độ ${blockMeasured(score.speedMeasured, score.speedPts) ? `${score.speedPts ?? 0}/40` : "chưa đo"} · hài lòng ${blockMeasured(score.happyMeasured, score.happyPts) ? `${score.happyPts ?? 0}/20` : "chưa đo"})`}
    >
      {score.totalPts}
    </span>
  );
}
